import { render, staticRenderFns } from "./LogoUpload.vue?vue&type=template&id=09f52195&scoped=true&"
import script from "./LogoUpload.vue?vue&type=script&lang=js&"
export * from "./LogoUpload.vue?vue&type=script&lang=js&"
import style0 from "./LogoUpload.vue?vue&type=style&index=0&id=09f52195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f52195",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
